import { Button, Form, Input } from 'antd';
import { Observer } from 'mobx-react';
import { useMainStore } from 'store/mobXStores/mainStore';

export const LoginForm = props => {
	const mainStore = useMainStore();
	const { loginStore } = mainStore;

	const onLogin = values => {
		const { handleUserLogin } = loginStore;
		handleUserLogin(values);
	};

	return (
		<Observer>
			{() => {
				const { isLoading } = loginStore;
				return (
					<Form layout="vertical" name="login-form" onFinish={onLogin} className="modern-login-form">
						<Form.Item
							name="email"
							label="USER NAME"
							rules={[
								{
									required: true,
									message: 'Please input your email',
								},
								{
									type: 'email',
									message: 'Please enter a valid email!',
								},
							]}
						>
							<Input className="modern-login-input" placeholder="demo@example.com" />
						</Form.Item>
						<Form.Item
							name="password"
							label="PASSWORD"
							rules={[
								{
									required: true,
									message: 'Please input your password',
								},
							]}
						>
							<Input.Password className="modern-login-input" placeholder="••••••••" />
						</Form.Item>
						<Form.Item className="modern-login-button-wrapper">
							<Button type="primary" htmlType="submit" loading={isLoading} className="modern-login-button">
								Sign In
							</Button>
						</Form.Item>
					</Form>
				);
			}}
		</Observer>
	);
};

export default LoginForm;
